export const PHOTO_TYPES = {
  PHOTO: 'PHOTO',
  LOGO: 'LOGO',
  FOREGROUND: 'FOREGROUND',
};
